import React from 'lib/react';
import { EVChip, makeStyles } from 'lib/components';

const useStyles = makeStyles((theme) => ({
  newBadge: {
    backgroundColor: theme.evPalette.mango[100],
    color: theme.evPalette.mango[900],
    borderRadius: '10px',
    fontWeight: '700',
    fontSize: '10px',
    padding: '2px 8px',
    height: 'unset',
    lineHeight: '16px',
    textTransform: 'uppercase',
    '& .myev-MuiChip-label': {
      padding: '0px',
    },
  },
}));

function NewBadge(props) {
  const classes = useStyles();

  return (
    <EVChip
      className={classes.newBadge}
      label="New"
      {...props}
    />
  );
}

export default NewBadge;
